/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevPriceEventsStatusDto
 */
export interface DevPriceEventsStatusDto {
    /**
     * 
     * @type {boolean}
     * @memberof DevPriceEventsStatusDto
     */
    isNormal: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DevPriceEventsStatusDto
     */
    processingEnabled: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DevPriceEventsStatusDto
     */
    queueState: string | null;
}

/**
 * Check if a given object implements the DevPriceEventsStatusDto interface.
 */
export function instanceOfDevPriceEventsStatusDto(value: object): value is DevPriceEventsStatusDto {
    if (!('isNormal' in value) || value['isNormal'] === undefined) return false;
    if (!('processingEnabled' in value) || value['processingEnabled'] === undefined) return false;
    if (!('queueState' in value) || value['queueState'] === undefined) return false;
    return true;
}

export function DevPriceEventsStatusDtoFromJSON(json: any): DevPriceEventsStatusDto {
    return DevPriceEventsStatusDtoFromJSONTyped(json, false);
}

export function DevPriceEventsStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevPriceEventsStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isNormal': json['isNormal'],
        'processingEnabled': json['processingEnabled'],
        'queueState': json['queueState'],
    };
}

export function DevPriceEventsStatusDtoToJSON(json: any): DevPriceEventsStatusDto {
    return DevPriceEventsStatusDtoToJSONTyped(json, false);
}

export function DevPriceEventsStatusDtoToJSONTyped(value?: DevPriceEventsStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isNormal': value['isNormal'],
        'processingEnabled': value['processingEnabled'],
        'queueState': value['queueState'],
    };
}

